export function conditionalTextFormatted(text: string, isConditional: boolean, option1 = 's', option2 = '') {
	return `${text}${isConditional ? option1 : option2}`;
}
